import React from "react";
import Slider from "react-slick";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../../../assets/images/index";

// Images
import perfumeImg from "../../../assets/perfume.png";
import trashBinImg from "../../../assets/trashbin.png";
import cycleChildImg from "../../../assets/cyclechild.png";

import SampleNextArrow from "./SampleNextArrow";
import SamplePrevArrow from "./SamplePrevArrow";

const ProductsSection = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <div className="w-full pb-16">
      <Heading heading="Products" />
      <Slider {...settings}>

        {/* ✅ 1. Cycle FIRST */}
        <div className="px-2">
          <Product
            _id="P1008"
            img={cycleChildImg}
            productName="Kids Bicycle"
            color="Mixed"
            badge={true}
            des="Safe and fun bicycle designed for children."
          />
        </div>

        {/* ✅ 2. Trash Bin SECOND */}
        <div className="px-2">
          <Product
            _id="P1007"
            img={trashBinImg}
            productName="Plastic Trash Bin"
            color="Green"
            badge={false}
            des="Durable trash bin suitable for home and office use."
          />
        </div>

        {/* Existing products */}
        <div className="px-2">
          <Product
            _id="P1001"
            img={newArrOne}
            productName="LED Desk Lamp"
            color="White"
            badge={true}
            des="Energy-saving LED desk lamp suitable for office and home."
          />
        </div>

        <div className="px-2">
          <Product
            _id="P1002"
            img={newArrTwo}
            productName="Smart Watch"
            color="Black"
            badge={true}
            des="High-quality smartwatch with heart rate and step tracking."
          />
        </div>

        <div className="px-2">
          <Product
            _id="P1003"
            img={newArrThree}
            productName="Cloth Storage Basket"
            color="Mixed"
            badge={true}
            des="Durable and stylish basket for home organization."
          />
        </div>

        <div className="px-2">
          <Product
            _id="P1004"
            img={newArrFour}
            productName="Kids Educational Toys"
            color="Mixed"
            badge={false}
            des="Safe and fun toys for toddlers and preschoolers."
          />
        </div>

        <div className="px-2">
          <Product
            _id="P1005"
            img={newArrTwo}
            productName="Wireless Earphones"
            color="Black"
            badge={false}
            des="Compact and high-quality Bluetooth earphones for music lovers."
          />
        </div>

        {/* ✅ 3. Perfume LAST */}
        <div className="px-2">
          <Product
            _id="P1006"
            img={perfumeImg}
            productName="Perfume Bottle"
            color="Assorted"
            badge={true}
            des="Premium fragrance perfume for daily use."
          />
        </div>

      </Slider>
    </div>
  );
};

export default ProductsSection;
